import request from '../utils/http.js';
const api = new Object()


//获取产品列表
api.productList = params => request('post', '/api/product/client/productList', params)


export default api